import { render } from "./CardVault.vue?vue&type=template&id=9283dd3c&scoped=true"
import script from "./CardVault.vue?vue&type=script&lang=js"
export * from "./CardVault.vue?vue&type=script&lang=js"

import "./CardVault.vue?vue&type=style&index=0&id=9283dd3c&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9283dd3c"]])

export default __exports__